(function () {
  /* X-Timer */
  class XTimer extends HTMLElement {
    constructor() {
      super();

      this.end = this.getAttribute('end');
      this.dateFormat = this.getAttribute('date-format') || null;
      this.message = this.getAttribute('message');
      this.showDays = this.getAttribute('show-days') === 'true';
      this.parent = this.getAttribute('parent');
      this.separatorNominal = this.getAttribute('separator-nominal') === 'true';
      this.acumulateHours = this.getAttribute('acumulate-hours') === 'true';
    }
    connectedCallback() {
      this.run();
    }
    _parseDate(format = 'br') {
      const [date, time] = this.end.split(' ');

      switch (format) {
        case 'br':
          const [day, month, year] = date.split('/');
          const [hour, minute, second] = time.split(':');

          return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
      }
    }
    run() {
      /**
       * Timer format: yyyy-mm-ddTHH:mm:ssZ
       * Example: 2026-02-10T00:00:00Z (standard of the date & time for shopify field type)
       */
      const endAt = this.dateFormat ? this._parseDate(this.dateFormat) : this.end;
      const endTimestamp = new Date(endAt).getTime();

      const intervalTime = setInterval(() => {
        const now = new Date().getTime();
        const distance = endTimestamp - now;

        if (distance < 0) {
          if (this.parent) {
            const parent = this.closest(this.parent);

            parent ? parent.remove() : this.remove();
          } else {
            this.remove();
          }
          return clearInterval(intervalTime);
        }

        const _days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const _hours =
          Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) +
          (this.acumulateHours === true ? _days * 24 : 0);
        const _minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const _seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (typeof callback === 'function') {
          return callback(_days, _hours, _minutes, _seconds);
        }

        let response = '';

        const formatter = (value) => {
          const interedValue = parseInt(value);
          const quocient = parseInt(interedValue / 10);
          const modRest = parseInt(interedValue % 10);

          return `<span class="x-timer__value-part">${quocient}</span><span class="x-timer__value-part">${modRest}</span>`;
        };

        if (this.showDays === true && _days > 0) {
          response +=
            `<span class="x-timer__value" data-value="Dias">${formatter(('00' + _days).slice(-2))}</span>` +
            '<span class="x-timer__separator">d</span> ';
        }
        response +=
          `<span class="x-timer__value" data-value="Horas">${formatter(('00' + _hours).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">h</span> ' : ':');
        response +=
          `<span class="x-timer__value" data-value="Minutos">${formatter(('00' + _minutes).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">m</span> ' : ':');
        response +=
          `<span class="x-timer__value" data-value="Segundos">${formatter(('00' + _seconds).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">s</span>' : '');

        this.innerHTML = `${this.message || ''} ${response}`.trim();
      }, 1000);
    }
  }
  if (!window.customElements.get('x-timer')) {
    window.customElements.define('x-timer', XTimer);
  }

  /** Subscription */
  class XSubscription extends HTMLElement {
    constructor() {
      super();

      this.variantSelect = this.querySelector('[name="id"]');
      this.handle = this.getAttribute('handle');
      this.form = document.getElementById(this.getAttribute('form'));
      this.variants = [];
      this.options = this.querySelectorAll('.subscription__option input');
    }

    connectedCallback() {
      this.options.forEach((el) => {
        el.addEventListener('change', this.onChange.bind(this));
      });
      this.variantSelect?.addEventListener('change', this.changeVariant.bind(this));
      this.fetchVariants(this.handle, this.init.bind(this));
      window.addEventListener('hashchange', this.init.bind(this));
    }

    init() {
      const url = new URLSearchParams(window.location.search);

      if (url.get('variant')) {
        const variantId = url.get('variant');

        if (variantId && this.form) {
          const selectedVariant = this.variants.find((variant) => variant.id == variantId);
          const formIdElement = this.querySelector('select[name="id"]');

          if (selectedVariant && formIdElement) {
            this.querySelectorAll('.subscription__option input[name="option2"]').forEach((el) => {
              el.disabled = el.dataset.option1 != selectedVariant.option1;
              el.checked = el.dataset.option1 == selectedVariant.option1 && el.value == selectedVariant.option2;
            });
            this.querySelectorAll('.subscription__option input[name="option3"]').forEach((el) => {
              el.disabled = el.dataset.option2 != selectedVariant.option2;
              el.checked = el.dataset.option2 == selectedVariant.option2 && el.value == selectedVariant.option3;
            });

            formIdElement.value = selectedVariant.id;
            formIdElement.dispatchEvent(new Event('change'));

            this.changeFeaturedImage(selectedVariant);
            this.selectGift(selectedVariant);
          }
        }
      }
    }

    async fetchVariants(handle, callback = null) {
      if (!handle) {
        return;
      }

      try {
        const response = await fetch(`${window.location.origin}/products/${handle}?view=variants`, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((r) => {
          return r.text();
        });
        const product = JSON.parse(response);

        this.variants = product.variants;

        if (typeof callback === 'function') {
          callback.call(this, this.variants);
        }
      } catch (err) {
        console.error(err);
      }
    }

    onChange(e) {
      e.preventDefault();

      const [option1, option2, option3] = this.querySelectorAll('.subscription__option input:checked');

      /**
       * Find the variant based on selected options.
       */
      const selectedVariant = this.variants.find(
        (variant) =>
          variant.option1 === option1.value && variant.option2 === option2.value && variant.option3 === option3.value,
      );

      /**
       * Render the benefits from selected variant.
       */
      if (this.variantSelect && selectedVariant) {
        const benefitsHtml = this.querySelector('#subscription-benefits');

        new Image().src = selectedVariant.image;

        /**
         *
         */
        this.variantSelect.value = selectedVariant.id;
        this.variantSelect.dispatchEvent(new Event('change'));

        if (benefitsHtml) {
          const { benefits } = selectedVariant.metafields;

          if (benefits && benefits.length > 0) {
            benefitsHtml.innerHTML = `<ul><li>${benefits.join('</li><li>')}</li></ul>`;
          } else {
            benefitsHtml.innerHTML = '';
          }
        }
      }

      this.render(option1, option2);

      if (this.form) {
        const formIdElement = this.form.querySelector('[name="id"]');

        if (formIdElement && selectedVariant) {
          formIdElement.value = selectedVariant.id;
        }
      }

      this.changeFeaturedImage(selectedVariant);
      this.selectGift(selectedVariant);
    }

    render(option1, option2) {
      /**
       * Select items for render based on before option
       */
      this.querySelectorAll('.subscription__option input[name="option2"]').forEach(
        (el) => (el.disabled = el.dataset.option1 != option1.value),
      );
      this.querySelectorAll('.subscription__option input[name="option3"]').forEach(
        (el) => (el.disabled = el.dataset.option2 != option2.value),
      );

      /**
       * Mark the first element
       */
      const option3Items = this.querySelectorAll('.subscription__option input[name="option3"]');

      if (option3Items.length > 0) {
        const checkedVisibleInput = this.querySelectorAll(
          '.subscription__option input[name="option3"]:not([disabled]):checked',
        );

        if (checkedVisibleInput.length === 0) {
          const input = Array.from(option3Items)
            .map((el) => {
              el.checked = false;
              return el;
            })
            .filter((el) => el.disabled == false)[0];

          input.checked = true;
          input.dispatchEvent(new Event('change'));
        }
      }
    }

    selectGift(selectedVariant) {
      const giftIds = Array.from(selectedVariant.metafields.gifts).map((g) => g.id.toString());
      this.querySelectorAll('[name="gift"]').forEach((el) => {
        el.disabled = !giftIds.includes(el.value);
      });
    }

    changeFeaturedImage(variant) {
      try {
        const image = this.closest('.featured-product').querySelector('media-gallery .product__media img');

        if (image) {
          image.src = variant.image;
          image.srcset = '';
        }
      } catch (err) {
        console.error('[SUBSCRIPTION]', err);
      }
    }

    changeVariant(e) {
      const url = new URLSearchParams(window.location.search);

      url.set('variant', e.target.value);
      window.history.replaceState({}, '', `${window.location.pathname}?${url.toString()}`);
    }
  }

  if (!window.customElements.get('x-subscription')) {
    window.customElements.define('x-subscription', XSubscription);
  }
})();
